import React, {Fragment, useContext, useState, useEffect} from 'react';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';

import {InvitesContext} from "../context/InvitesContext";
import {handleChangeFactory} from "../utils/EventHandlerUtils";
import formValidation from '../utils/FormValidation';
import { ReactComponent as CheckmarkSvg } from '../assets/check-icon.svg';

export default function ChurchDetails(props) {
    const { classes, setPhoneConfirmationStepIsValid } = props;
    const invitesContext = useContext(InvitesContext);
    const [formErrors, setFormErrors] = useState({});
    const handleChange = handleChangeFactory(invitesContext.dispatch);

    const fieldsValidation = {
        phoneConfirmationNumber: {
          error: '',
          validate: 'phone'
        }
    }

    const handlePhoneChange = (e) => {
        invitesContext.dispatch({ type: 'CHANGE_VALUE', name: 'phoneConfirmationNumber', value: e.target.value});
        const error = (e.target.value && formValidation(e.target.name, e.target.value, fieldsValidation)) || '';
        setFormErrors({[e.target.name]: error});
    };

    const stepIsValid = 
        (invitesContext.state.invite.phoneConfirmation &&
            invitesContext.state.invite.phoneConfirmationName &&
            invitesContext.state.invite.phoneConfirmationNumber && 
            !formErrors.phoneConfirmationNumber
        ) || 
        (invitesContext.state.invite.rsvpConfirmation);
    useEffect(() => {
        setPhoneConfirmationStepIsValid(stepIsValid);
    });

    const [phoneConfirmation, setPhoneConfirmation] = useState(invitesContext.state.invite.phoneConfirmation);
    const [rsvpConfirmation, setRsvpConfirmation] = useState(invitesContext.state.invite.rsvpConfirmation);
    const handlePhoneConfirmation = () => {
        let newPhoneConfirmation = !phoneConfirmation;
        setPhoneConfirmation(newPhoneConfirmation);
        invitesContext.dispatch({ type: 'CHANGE_VALUE', name: 'phoneConfirmation', value: newPhoneConfirmation});
    };
    
    const handleRsvpConfirmation = () => {
        let newRsvpConfirmation = !rsvpConfirmation;
        setRsvpConfirmation(newRsvpConfirmation);
        invitesContext.dispatch({ type: 'CHANGE_VALUE', name: 'rsvpConfirmation', value: newRsvpConfirmation});
    };

    return (
        <Fragment>
                <Grid container spacing={2} noValidate className={classes.inputContainer}>
                    <Grid item xs={12} className={classes.noPadding}>
                        <FormControlLabel
                            className={classes.checkbox}
                            control={
                                <Checkbox
                                    checked={invitesContext.state.invite.phoneConfirmation}
                                    onChange={handlePhoneConfirmation}
                                    name="consentPromo"
                                    color="primary"
                                    checkedIcon={<CheckmarkSvg />}
                                />
                            }
                            label="Confirmare telefonică"
                        />
                    </Grid>
                    { invitesContext.state.invite.phoneConfirmation &&
                        <Fragment>
                            <Grid item xs={12} className={classes.noPadding}>
                                <Paper square elevation={0} className={classes.inputTitleContainer}>
                                    <Typography className={classes.inputTitleText}>Nume *</Typography>
                                </Paper>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    className={classes.inputFieldContainer}
                                    name="phoneConfirmationName"
                                    placeholder="Nume persoană contact"
                                    onChange={handleChange}
                                    value={invitesContext.state.invite.phoneConfirmationName}
                                />
                            </Grid>
                            <Grid item xs={12} className={classes.noPadding}>
                                <Paper square elevation={0} className={classes.inputTitleContainer}>
                                    <Typography className={classes.inputTitleText}>Telefon *</Typography>
                                </Paper>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    className={classes.inputFieldContainer}
                                    name="phoneConfirmationNumber"
                                    placeholder="Telefon"
                                    onChange={handlePhoneChange}
                                    value={invitesContext.state.invite.phoneConfirmationNumber}
                                    error={!!formErrors.phoneConfirmationNumber}
                                    helperText={formErrors.phoneConfirmationNumber}
                                />
                            </Grid>
                        </Fragment>
                    }
                    <Grid item xs={12} className={`${classes.noPadding} ${classes.mb20}`}>
                        <FormControlLabel
                            className={classes.checkbox}
                            control={
                                <Checkbox
                                    checked={invitesContext.state.invite.rsvpConfirmation}
                                    onChange={handleRsvpConfirmation}
                                    name="consentPromo"
                                    color="primary"
                                    checkedIcon={<CheckmarkSvg />}
                                />
                            }
                            label={
                                <div className='tooltip'>
                                    Confirmare prin RSVP
                                    <Tooltip disableFocusListener enterTouchDelay={0} leaveTouchDelay={3000} title="Face parte din My Belle Event. Poti vedea gratuit doar ultimele 5 confirmari.">
                                        <InfoIcon />
                                    </Tooltip>
                                </div>
                            }
                        />
                    </Grid>
                </Grid>
        </Fragment>
    )
}